module.exports = {
	"pagination": {
		"BatchGetItem": {
			"input_token": "RequestItems",
			"output_token": "UnprocessedKeys"
		},
		"ListTables": {
			"input_token": "ExclusiveStartTableName",
			"output_token": "LastEvaluatedTableName",
			"limit_key": "Limit",
			"result_key": "TableNames"
		},
		"Query": {
			"input_token": "ExclusiveStartKey",
			"output_token": "LastEvaluatedKey",
			"limit_key": "Limit",
			"result_key": "Items"
		},
		"Scan": {
			"input_token": "ExclusiveStartKey",
			"output_token": "LastEvaluatedKey",
			"limit_key": "Limit",
			"result_key": "Items"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/dynamodb-2011-12-05.paginators.json
 ** module id = 1287
 ** module chunks = 0
 **/